export default "__VITE_ASSET__V7MkT1yJ__"